export const getStatusColor = (status) => {
  switch (status) {
    case 0:
      return "bg-yellow-100 text-yellow-800"; // Pending
    case 1:
      return "bg-yellow-100 text-yellow-800"; // Completed
    case 2:
      return "bg-yellow-100 text-yellow-800";
    case 3:
      return "bg-green-100 text-green-800";
    case 4:
      return "bg-green-100 text-green-800";
    case 5:
      return "bg-green-100 text-green-800";
    case 6:
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};
export const getStatusText = (status) => {
  switch (status) {
    case 0:
      return "Pickup";
    case 1:
      return "Pickup";
    case 2:
      return "Pickup Complete";
    case 3:
      return "Processing";
    case 4:
      return "Delivery";
    case 5:
      return "Delivery Done";
    case 6:
      return "Cancelled";
    default:
      return "Unknown";
  }
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const openDirections = (lat, lng) => {
  window.open(`https://www.google.com/maps?q=${lat},${lng}`);
};

export const isObjectEmpty = (obj) => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
};
